/* src/app/modules_v2/booking/availability/components/location-schedule/location-schedule.component.css */
.schedule-container {
  padding: 20px;
}
h3 {
  color: var(--cf-chrome);
  margin-bottom: 16px;
}
/*# sourceMappingURL=location-schedule.component.css.map */
